export default __webpack_public_path__ + "static/media/circle-cross-red.c9afa2b3.svg";